<template>
    <div class="setmeal">
        <z-title title="套餐设置" ref="title"></z-title>
        <el-card class="content1" ref="search">
           <div class="flex-n fac fjb ">
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    maxlength="32"
                    placeholder="输入套餐名称"
                    title="输入套餐名称"
                    clearable
                    prefix-icon="el-icon-search"
                    v-model="packageName">
            </el-input>
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn2" @click="searchSetmeal">查询</el-button>
                <el-button type="primary" class="ele-btn1" @click="addSetmeal">新增套餐</el-button>
            </div>
           </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        prop="orderIndex"
                        fixed
                        label="套餐排序"
                        width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed
                        prop="packageName"
                        label="套餐名称"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        align="center"
                        label="类 型"
                        min-width="150">
                    <template slot-scope="scope">
                        <template v-for="item,index in packageTypeList" v-if="item.dicCode==scope.row.packageTypeCode">
                            {{item.dicName}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="packagePriceOld"
                        label="套餐原价"
                        min-width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="packagePrice"
                        label="套餐现价"
                        min-width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="detailInfo"
                        label="套餐详情"
                        min-width="350"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备 注"
                        min-width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                        align="center">
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">
                            <el-button type="primary" class="ele-btn-small mr-10" @click="editSetmeal(scope.row.id,scope.row.packageTypeCode)">编辑</el-button>
                            <el-popconfirm
                                    title="确定删除该套餐吗？"
                                    @confirm="delSetmeal(scope.row.id,scope.row.packageTypeCode)"
                            >
                            <el-button slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--新增套餐-->
        <el-dialog :visible.sync="showedit"
                    class="ele-toast" :close-on-click-modal="false"   width="750px">
            <div slot="title">
                <z-title :title="editstate+'套餐'"></z-title>
            </div>
            <el-form :model="dataForm" :rules="rules" ref="dataForm" class="rulefrom">
                <el-form-item label="套餐名称" prop="packageName" label-width="80px">
                    <el-input maxlength="32"  v-model="dataForm.packageName" placeholder="请输入套餐名称"></el-input>
                </el-form-item>
                <el-form-item label="套餐排序" prop="orderIndex" label-width="80px">
                    <el-input maxlength="16" class="w-120" style="text-align: left;!important;" v-model="dataForm.orderIndex" placeholder="请输入场地排序" v-number></el-input>
                </el-form-item>
                <el-form-item label="套餐原价" prop="packagePriceOld" label-width="80px">
                    <el-input-number placeholder="请输入套餐原价" v-model="dataForm.packagePriceOld" :precision="2" :step="0.1" controls-position="right"   :max="9999999999"></el-input-number>
                </el-form-item>
                <el-form-item label="套餐现价" prop="packagePrice" label-width="80px">
                    <el-input-number placeholder="请输入套餐现价" v-model="dataForm.packagePrice" :precision="2" :step="0.1" controls-position="right"   :max="9999999999"></el-input-number>
                </el-form-item>
                <el-form-item label="套餐类型" prop="packageTypeCode" label-width="80px" >
                    <el-radio-group v-model="dataForm.packageTypeCode"  @change="changePackage">
                        <el-radio v-for="item,index in packageTypeList" :label="item.dicCode">{{item.dicName}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="套餐详情" prop="packageDetails" label-width="80px">
                    <div class="tc_details" readonly v-if="dataForm.packageDetails">
                        {{dataForm.packageDetails}}
                    </div>
                    <el-button type="primary" size="mini" @click="showextra=true">编辑额外项目</el-button>
                </el-form-item>
                <el-form-item label="备 注" prop="remark" label-width="80px">
                    <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                              maxlength="512"></el-input>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('dataForm')">保 存</el-button>
                    <el-button @click="showedit = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--编辑额外项目-->
        <itemextra ref="extra" :visible.sync="showextra"   :statetype="dataForm.packageTypeCode" v-model="extraArea" @getTotal="getTotal"></itemextra>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Itemextra from "../component/itemextra";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            Itemextra,
            ZTitle},
        name: "setmeal",
        data() {
            return {
                extraArea:{},
                oldextraArea1:{},
                oldextraArea2:{},
                loading: false,
                pageSize: 20,
                height:250,
                currentPage: 1,
                total: 0,
                dataForm:{
                    packageName:'',
                    packageTypeCode:'01',
                    packagePriceOld:'',
                    packagePrice:'',
                    packageDetails:'',
                    remark:''
                },
                editstate: '新增',
                showedit: false,


                packageName: '',//套餐名称
                packageTypes:[],
                id:'',
                showextra:false,
                packageTypeList:[],

                rules: {
                    packageName:[{ required: true, message: '套餐名称不能为空', trigger: 'blur'}],
                    // packageTypeCode: [{ required: true, message: '套餐类型不能为空', trigger: 'blur'}],
                    // packagePriceOld:[{ required: true, message: '套餐原价不能为空', trigger: 'blur'}],
                    // packagePrice: [{ required: true, message: '套餐现价不能为空', trigger: 'blur'}],
                    // packageDetails:[{ required: true, message: '套餐详情不能为空', trigger: 'blur'}],
                },
                dataList: [],
            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.getSetmealList();
            this.getStateList();
        },
        watch:{
            showedit(newval,oldval){
                console.log(newval)
                if(!newval){
                    this.oldextraArea1={};
                    this.oldextraArea2={};
                    this.$refs.dataForm.resetFields();
                    this.$refs.extra.resetCard();
                }
            }
        },
        methods: {
            //更改套餐
            changePackage(data){
                console.log(data)
                //选择了婚庆，保存普通
                if(this.dataForm.packageTypeCode!='01'){
                    this.oldextraArea1=this.extraArea;
                    this.extraArea=this.oldextraArea2;
                }else{
                    this.oldextraArea2=this.extraArea;
                    this.extraArea=this.oldextraArea1;
                }
                console.log('现在的',this.extraArea)
                this.getTotal();
            },
            getTotal(price){
                console.log(price)
                var data=this.extraArea;
                console.log(data)
                var packageDetails='';
                for(var i in data.itemsExTree){
                    packageDetails +=data.itemsExTree[i].itemName+'*'+data.itemsExTree[i].itemCount+'、';
                }
                for(var i in data.itemsFoodTree){
                        packageDetails+=data.itemsFoodTree[i].foodName+'*'+data.itemsFoodTree[i].foodCount+'、';
                }
                if(packageDetails.length>0)
                this.dataForm.packageDetails=packageDetails.substring(0,packageDetails.length-1);
                else{
                    this.dataForm.packageDetails='';
                }
            },
            //查询套餐列表
            getSetmealList(){
                this.loading=true;
                this.$axios.post('/foodPackage/foodPackageListDetail', {
                    "storeId": this.$root.getStorage('storeId'),
                    "packageName": this.packageName,
                    "pageSize": this.pageSize,
                    "currentPage": this.currentPage
                }).then(res => {
                    console.log('套餐列表', res)
                    this.dataList = res.data.list;
                    this.total = res.data.total;
                    this.getStateList();
                    this.loading=false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading=false;
                })
            },
            getStateList(){
                if(this.$root.getStorage('dic')){
                    this.packageTypeList=this.$root.getStorage('dic').filter((item)=>item.dicType=='package_type');
                }else{
                    this.$store.state.dicChange=true;
                    this.getSetmealList();
                }
            },
            //搜索
            searchSetmeal(){
                this.currentPage=1;
                this.getSetmealList();
            },
            //添加
            addSetmeal() {
                this.showedit = true;
                this.editstate = '新增'
            },
            //编辑
            editSetmeal(id,packageTypeCode) {
                console.log('编辑',id)
                this.id=id;
                this.showedit = true;
                this.editstate = '编辑';
                this.$axios.post('/foodPackage/foodPackageByIdAndType/',{
                    'id':id,
                    'packageTypeCode':packageTypeCode
                }).then(res=>{
                    console.log(res)
                    this.dataForm=res.data;
                    var itemsFoodTree=[],itemsExTree=[];
                    if(packageTypeCode=='01'){
                        for(var i in res.data.itemsFoodTree){
                            itemsFoodTree.push({
                                id:res.data.itemsFoodTree[i].itemId,
                                foodCount:res.data.itemsFoodTree[i].itemCount,
                                foodPrice:res.data.itemsFoodTree[i].itemPrice,
                                foodName:res.data.itemsFoodTree[i].itemName,
                            })
                        }
                        for(var i in res.data.itemsExTree){
                            itemsExTree.push({
                                id:res.data.itemsExTree[i].itemId,
                                itemCount:res.data.itemsExTree[i].itemCount,
                                itemPrice:res.data.itemsExTree[i].itemPrice,
                                itemName:res.data.itemsExTree[i].itemName
                            })
                        }
                    }else{
                        for(var i in res.data.itemsWeddingTree){
                            itemsExTree.push({
                                id:res.data.itemsWeddingTree[i].itemId,
                                itemCount:res.data.itemsWeddingTree[i].itemCount,
                                itemPrice:res.data.itemsWeddingTree[i].itemPrice,
                                itemName:res.data.itemsWeddingTree[i].itemName
                            })
                        }
                    }
                    this.extraArea={
                        itemsFoodTree:itemsFoodTree,
                        itemsExTree:itemsExTree
                    }
                    this.getTotal();

                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            delSetmeal(id,packageTypeCode){
                this.$axios.post('/foodPackage/foodPackageDeleteByIdAndType',{
                    "id": id,
                    "packageTypeCode": packageTypeCode
                }).then(res=>{
                    this.$message.success('删除套餐成功！');
                    this.getSetmealList();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //添加提交
            addSubmit(){
                var itemsExTree=[],itemsFoodTree=[],itemsWeddingTree=[];
                var area=this.extraArea;
                console.log(area)
                if(this.dataForm.packageTypeCode=='01'){
                    for(var i in area.itemsExTree){
                        itemsExTree.push({
                            "itemCount": area.itemsExTree[i].itemCount,
                            "itemId": area.itemsExTree[i].id,
                            "itemName": area.itemsExTree[i].itemName,
                            "packageId":area.itemsExTree[i].packageId,
                        })
                    }
                    for(var i in area.itemsFoodTree){
                        itemsFoodTree.push({
                            "itemCount": area.itemsFoodTree[i].foodCount,
                            "itemId": area.itemsFoodTree[i].id,
                            "itemName": area.itemsFoodTree[i].foodName,
                            "packageId":area.itemsFoodTree[i].packageId,
                        })

                    }
                }else{
                    for(var i in area.itemsExTree){
                        itemsWeddingTree.push({
                            "itemCount": area.itemsExTree[i].itemCount,
                            "itemId": area.itemsExTree[i].id,
                            "itemName": area.itemsExTree[i].itemName,
                            "packageId":area.itemsExTree[i].packageId,
                        })
                    }
                }
                let {orderIndex,packageName,packageTypeCode,packagePriceOld,packagePrice,remark}=this.dataForm;
                console.log(this.dataForm)
                this.$axios.post('/foodPackage/foodPackageAdd',{
                    "storeId": this.$root.getStorage('storeId'),
                    "packageName": packageName,
                    "packageTypeCode": packageTypeCode,
                    "packagePriceOld": packagePriceOld,
                    "itemsExTree":itemsExTree,
                    "itemsFoodTree":itemsFoodTree,
                    "itemsWeddingTree":itemsWeddingTree,
                    "packagePrice":packagePrice,
                    "orderIndex":orderIndex,
                    "remark": remark
                }).then(res=>{
                    this.currentPage = 1;
                    this.getSetmealList();
                    this.$message.success('新增套餐成功！');
                    this.showedit = false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit(){
                var itemsExTree=[],itemsFoodTree=[],itemsWeddingTree=[];
                var area=this.extraArea;
                if(this.dataForm.packageTypeCode=='01'){
                    for(var i in area.itemsExTree){
                        itemsExTree.push({
                            "itemCount": area.itemsExTree[i].itemCount,
                            "itemId": area.itemsExTree[i].id,
                            "itemName": area.itemsExTree[i].itemName,
                            "packageId":area.itemsExTree[i].packageId,
                        })
                    }
                    for(var i in area.itemsFoodTree){
                        itemsFoodTree.push({
                            "itemCount": area.itemsFoodTree[i].foodCount,
                            "itemId": area.itemsFoodTree[i].id,
                            "itemName": area.itemsFoodTree[i].foodName,
                            "packageId":area.itemsFoodTree[i].packageId,
                        })

                    }
               }else{
                    for(var i in area.itemsExTree){
                        itemsWeddingTree.push({
                            "itemCount": area.itemsExTree[i].itemCount,
                            "itemId": area.itemsExTree[i].id,
                            "itemName": area.itemsExTree[i].itemName,
                            "packageId":area.itemsExTree[i].packageId,
                        })
                    }
                }
                console.log('itemsExTree',itemsExTree,'itemsFoodTree',itemsFoodTree)
                let {orderIndex,packageName,packageTypeCode,packagePriceOld,packagePrice,remark}=this.dataForm;
                this.$axios.post('/foodPackage/foodPackageUpdate',{
                    "storeId": this.$root.getStorage('storeId'),
                    "id":this.id,
                    "packageName": packageName,
                    "packageTypeCode": packageTypeCode,
                    "packagePriceOld": packagePriceOld,
                    "itemsExTree":itemsExTree,
                    "itemsFoodTree":itemsFoodTree,
                    "itemsWeddingTree":itemsWeddingTree,
                    "orderIndex":orderIndex,
                    "packagePrice":packagePrice,
                    "remark": remark
                }).then(res=>{
                    this.$message.success('编辑套餐成功！');
                    this.getSetmealList();
                    this.showedit = false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.editstate == '新增'){
                            this.addSubmit();
                        }else{
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getSetmealList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.getSetmealList();
                console.log(`当前页: ${val}`);
            },
        },
    }
</script>

<style scoped lang="scss">
    .setmeal {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
        .tc_details{
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            padding: 0 15px;
        }
    }
</style>